import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../../components/doctors/partials/Header';
import TopLeftMenu from '../../components/doctors/partials/topLeftMenu';
import { deleteRequest, getRequest } from '../../utils/axiosRequests';
import {
  capitalizeFirstLetter,
  deleteConfirmation,
  getPatientIdForDoctor,
} from '../../utils/helpers';

function OtList() {
  const [otEntries, setOtEntries] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 15;
  const [patientNameFilter, setPatientNameFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.authReducer.data);
  const activeDoctor = useSelector(
    (state) => state.doctorsOfAssistantReducer.activeDoctor,
  );

  const fetchOtEntries = (page, nameFilter, statFilter) => {
    setIsLoading(true);
    let url = `ot-list?page=${page}&perPage=${perPage}`;
    if (nameFilter) url += `&q=${encodeURIComponent(nameFilter)}`;
    if (statFilter) url += `&status=${statFilter}`;
    getRequest(url)
      .then((data) => {
        setIsLoading(false);
        const entries = data?.otList || data?.otEntries || data?.data || [];
        const count = data?.total ?? entries.length;
        if (page === 1) {
          setOtEntries(entries);
          setTotal(count);
        } else {
          setOtEntries((prev) => [...prev, ...entries]);
          setTotal(count);
        }
      })
      .catch(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchOtEntries(currentPage, patientNameFilter, statusFilter);
  }, [currentPage]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      fetchOtEntries(1, patientNameFilter, statusFilter);
    }
  };

  const handleClear = () => {
    setPatientNameFilter('');
    setStatusFilter('');
    setCurrentPage(1);
    fetchOtEntries(1, '', '');
  };

  const deleteOtEntry = (id) => {
    deleteRequest(`ot-list/${id}`).then(() => {
      setOtEntries((prev) => prev.filter((e) => e._id !== id));
      setTotal((t) => t - 1);
    });
  };

  const statusBadgeClass = (status) => {
    if (status === 'completed') return 'bg-success';
    if (status === 'cancelled') return 'bg-danger';
    if (status === 'scheduled') return 'bg-primary';
    return 'bg-warning text-dark';
  };

  console.log('otEntries: ', otEntries);

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-md-12 sticky-header shadow header-sticky-second">
            <TopLeftMenu />
          </div>
        </div>
        <Row className="rx-body">
          <div className="col-xl-12 col-md-12 col-lg-12">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Form onSubmit={handleSearch}>
                  <Row className="align-items-end g-2">
                    <Col xs={12} sm={2}>
                      <h6 className="m-0 font-weight-bold text-primary">
                        OT List
                      </h6>
                      <span className="show_row_number">
                        {otEntries.length} of {total}
                      </span>
                    </Col>
                    <Col xs={12} sm={3}>
                      <Form.Control
                        size="sm"
                        placeholder="Search by patient name, patient Id"
                        value={patientNameFilter}
                        onChange={(e) => setPatientNameFilter(e.target.value)}
                      />
                    </Col>
                    <Col xs={12} sm={2}>
                      <Form.Select
                        size="sm"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="scheduled">Scheduled</option>
                        <option value="completed">Completed</option>
                        <option value="cancelled">Cancelled</option>
                      </Form.Select>
                    </Col>
                    <Col xs="auto">
                      <Button size="sm" type="submit" variant="primary">
                        Search
                      </Button>
                    </Col>
                    <Col xs="auto">
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        type="button"
                        onClick={handleClear}
                      >
                        Clear
                      </Button>
                    </Col>
                    <Col className="text-end">
                      <Link
                        to="/new-ot-entry"
                        className="btn btn-sm btn-success"
                      >
                        <i className="fa fa-plus" /> New Entry
                      </Link>
                    </Col>
                  </Row>
                </Form>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <Table bordered hover size="sm" className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Patient Name</th>
                        <th>Age</th>
                        <th>Reg. No</th>
                        <th>Ward/Bed</th>
                        <th>Indication</th>
                        <th>Operation</th>
                        <th>Eye</th>
                        <th>Anaesthesia</th>
                        <th>Surgeons</th>
                        <th>Status</th>
                        <th>OT Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading && (
                        <tr>
                          <td colSpan={13} className="text-center py-3">
                            Loading...
                          </td>
                        </tr>
                      )}
                      {!isLoading && otEntries.length === 0 && (
                        <tr>
                          <td
                            colSpan={13}
                            className="text-center py-3 text-muted"
                          >
                            No entries found
                          </td>
                        </tr>
                      )}
                      {otEntries.map((entry, idx) => (
                        <tr key={entry._id}>
                          <td>{(currentPage - 1) * perPage + idx + 1}</td>
                          <td>
                            <div>
                              <span style={{ display: 'block' }}>
                                {entry.patient_name}
                              </span>
                              {/* <span>{entry.patient_name}</span> */}
                            </div>
                            {(() => {
                              const doctor =
                                userInfo.userType === 'assistant'
                                  ? activeDoctor
                                  : userInfo;

                              const pid = getPatientIdForDoctor(
                                entry.patientId?.patientIdForDoctor,
                                doctor,
                              );

                              return pid ? (
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: '#666',
                                    paddingTop: '3px',
                                  }}
                                >
                                  ({pid})
                                </div>
                              ) : null;
                            })()}
                          </td>
                          <td>{entry.Age || entry.age || ''}</td>
                          <td>{entry.registration_no}</td>
                          <td>{entry.ward_bed}</td>
                          <td>{entry.indication}</td>
                          <td>{entry.operation}</td>
                          <td>{entry.eye || ''}</td>
                          <td>
                            {entry.aneasthesia || entry.anaesthesia || ''}
                          </td>
                          <td>{entry.surgeons_name}</td>
                          <td>
                            <span
                              className={`badge ${statusBadgeClass(entry.status)}`}
                            >
                              {capitalizeFirstLetter(entry.status || '')}
                            </span>
                          </td>
                          <td>
                            {entry.ot_date
                              ? moment(entry.ot_date).format('DD MMM YYYY')
                              : ''}
                          </td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              className="me-1"
                              onClick={() =>
                                navigate('/edit-ot-entry', {
                                  state: { otEntry: entry },
                                })
                              }
                            >
                              <i className="fa fa-pencil-alt" />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              onClick={() =>
                                deleteConfirmation(deleteOtEntry, entry._id)
                              }
                            >
                              <i className="fa fa-times" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                {otEntries.length < total && (
                  <div className="text-center p-3">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      disabled={isLoading}
                      onClick={() => setCurrentPage((p) => p + 1)}
                    >
                      Load More ({total - otEntries.length} remaining)
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Row>
      </div>
    </div>
  );
}

export default OtList;
